import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { ActivationCenterResourceType } from 'modules/finance/components/FinancialWorkspace/components/ActivationCenter/enums'
import { MissingGrossSalaries } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/MissingGrossSalaries'
import { ReturnedData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useMissingAgreementData'
import { FROM_AC_COMPONENT } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/lib/trackConst'

const SOURCE_ID = 'activation_center_agreements'

export const agreementsResources = (data: ReturnedData) => {
  const missingData = data.totalCount > 0

  const resources = {
    completedData: {
      label: i18n.t('finance.financial_workspace.activation_center.sources.agreements'),
      type: ActivationCenterResourceType.FILLED,
      sourceId: SOURCE_ID,
    },
    missingData: {
      label: i18n.t('finance.financial_workspace.activation_center.sources.agreements'),
      type: ActivationCenterResourceType.MISSING_DATA,
      button: MissingGrossSalaries({
        type: 'button',
        customValues: {
          buttonText: i18n.t('finance.financial_workspace.activation_center.button.agreements'),
        },
        variables: {
          formattedStartDate: moment('1970-01-01').format('YYYY-MM-DD'),
          formattedEndDate: moment().format('YYYY-MM-DD'),
          period: 'monthly',
        },
        fromComponent: `${FROM_AC_COMPONENT}_agreements`,
      }),
      sourceId: SOURCE_ID,
    },
  }

  return resources[missingData ? 'missingData' : 'completedData']
}
